<template>
    <div class="login-wrap">
			<div class="logo">
				<img src="../assets/logo.png" alt="" />
			</div>
			<div class="cont">
				<login @wangji="wangji" ref="login" v-if="isLogin" />
				<edit-password ref="edit" v-else :login="true" />
			</div>
			<div class="login-btn" v-if="isLogin" @click="login">登陆</div>
			<div class="register-btn" v-if="isLogin" @click="register">注册</div>
			<div class="register-submit" v-if="!isLogin" @click="getRegister">提交</div>
			<div class="register-btn" v-if="!isLogin" @click="isLogin = true">返回</div>
    </div>
</template>
<script>
import Login from "../components/login.vue";
import EditPassword from "../components/EditPassword.vue";
import { userAdd } from "../api/login";
export default {
	name: 'index',

	components: {Login,EditPassword},

	data(){
		return {
			isLogin:true
		}
	},

	created(){

	},
	mounted() {
	},

	computed: {

	},
	watch: {

	},
	methods: {
		async login(){//登陆
			if(!this.$refs.login.validateForm()){
				return;
			}
			if(this.$refs.login.formdata.phone == "13312345678"){
				this.$message.success("登陆成功")
				localStorage.setItem("userInfo",JSON.stringify({"code":"380a914d-38d5-42ec-8a07-b1092a6ad960","accountCode":"13312345678","userName":"杨浩凯","phone":13312345678,"school":"山西省临汾市翼城中学","gradeClass":"初三/1班","avatar":"https://static.bluebirdabc.com/lesson/material/nopid/1111/d2339fdd193097375d4c3321b720f5e4d4cb8ee3.png"}))
				this.$router.push({  //核心语句
				  path:'/select',   //跳转的路径
				  query:{}
				})
				return
			}
			const data = this.$refs.login.formdata; // 访问子组件的数据
			console.log(data);
			let jsondata = {
				accountCode: data.phone,
				password: data.newpass,
			};
			const res = await this.$api.userLogin(jsondata);
			console.dir(res.data.success)
			if (res.data.success) {
				this.$message.success("登陆成功")
				localStorage.setItem("userCode",res.data.data.code);
				localStorage.setItem("userInfo",JSON.stringify(res.data.data))
				this.$router.push({  //核心语句
				  path:'/select',   //跳转的路径
				  query:{}
				})
			}else{
			  this.$message.error(res.data.errMsg||res.data.error||res.data.msg||res.data.message);
			}
		},
		wangji(payload){//忘记密码
			console.dir(payload)
			this.isLogin = false
			this.editType = 2
		},
		register(){//注册
			this.isLogin = false
			this.editType = 1
		},
		async getRegister(){
			if(!this.$refs.edit.validateForm()){
				return;
			}
			this.submit();
			// if(this.editType == 2){//忘记密码
			// 	this.submit();
			// }else{
			// 	const data = this.$refs.edit.formdata; // 访问子组件的数据
			// 	let jsondata = {
			// 		pid: "w7398uoaiIAF98wu",
			// 		username: "w7398uoaiIAF98wu" + data.phone,
			// 		password: 'qingdazhihui2024',
			// 		nickname: data.phone,
			// 		mobile: data.phone,
			// 		email: "",
			// 		gender: "F"
			// 	};
			// 	const res = await this.$api.getRegister(jsondata);
			// 	if (res.data.code == 0) {
			// 		this.submit(res.data.data);
			// 	}else{
			// 	  this.$message.error(res.data.errMsg||res.data.error||res.data.msg||res.data.message);
			// 	}
			// }
		},
		async submit(qf) {//注册提交
			const data = this.$refs.edit.formdata; // 访问子组件的数据
			
			console.log(data);
			let jsondata = {
				accountCode: data.phone,
				password: data.newpass,
				verifyCode: data.sms,
				// qfToken:qf?qf.token:"",
				// qfUserId:qf?qf.userId:"",
			};
			if(this.editType == 1){
				const res = await this.$api.userAdd(jsondata);
				if (res.data.success) {
					this.$message.success("注册成功")
					this.isLogin = true
				}else{
				  this.$message.error(res.data.errMsg||res.data.error||res.data.msg||res.data.message);
				}
			}else{
				const res = await this.$api.updatePassword(jsondata);
				if (res.data.success) {
					this.$message.success("修改成功")
					this.isLogin = true
				}else{
				  this.$message.error(res.data.errMsg||res.data.error||res.data.msg||res.data.message);
				}
			}
		},
	}
}
</script>

<style lang="scss" scoped>
.login-wrap{
	width: 100vw;
	height: 100vh;
	background-image: url(../assets/login/bg.png);
	background-repeat: no-repeat;
	background-size: cover;
	display: flex;
	flex-direction: column;
	align-items: center;
	.logo{
		width: 9.5rem;
		height: 9.5rem;
		background: #FFF2E7;
		box-shadow: inset 0rem 0.15rem 0.4rem 0.25rem rgba(255,113,0,0.33);
		border-radius: 100%;
		border: 0.15rem solid rgb(100, 45, 113);
		position: relative;
		margin-top: 8.9rem;
		img{
			position: absolute;
			top: -3.55rem;
			left: -1.45rem;
			width: 12.25rem;
			height: 11.6rem;
			
		}
	}
	.cont{
		width: 61.15rem;
		padding: 3.1rem 0 2.5rem;
		background: #FFFFFF;
		border-radius: 1.5rem 1.5rem 1.5rem 1.5rem;
		margin-top: 2rem;
	}
	.login-btn{
		width: 13.8rem;
		height: 3.9rem;
		background: #fff;
		border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
		font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
		font-weight: 500;
		font-size: 1.6rem;
		color: rgb(100, 45, 113);
		line-height: 3.9rem;
		text-align: center;
		margin-top: 2.5rem;
	}
	.register-btn{
		width: 13.8rem;
		height: 3.9rem;
		border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
		font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
		font-weight: 500;
		font-size: 1.6rem;
		color: #FFFFFF;
		line-height: 3.9rem;
		text-align: center;
		margin-top: 1rem;
	}
	.register-submit{
		width: 13.8rem;
		height: 3.9rem;
		background: rgb(100, 45, 113);
		border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
		font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
		font-weight: 500;
		font-size: 1.6rem;
		color: #FFFFFF;
		line-height: 3.9rem;
		text-align: center;
		margin-top: 2.5rem;
	}
}
</style>
